import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import '../../pages/event/HostEvent.css';

/* "You're in group 3" — what the host's one button press puts on the home of everybody in the
   room.

   ★ It renders from the HOME PAYLOAD, not from a request of its own. Nobody is in a breakout on
   the other 364 days, and a card that costs a round trip on every home load to discover that is
   the wrong trade. `breakout` is null the rest of the time and this draws nothing.

   ★ The group's NAME is made here, not stored. `group_name` is empty unless a host typed one (or
   an uploaded sheet named it), and the fallback is the number in the reader's own language — the
   same contract the run sheet's slot titles use. Storing "Group 3" server-side would be English
   for everybody, forever.

   ★ The people are the OTHERS. The reader knows they are in their own group; "with Ann, Bob and
   you" is not how anybody writes it, so `me` is filtered out here where the viewer is known. */

const MyBreakout = ({ breakout, me }) => {
  const { t } = useTranslation();
  if (!breakout) return null;

  const label = (breakout.group_name || '').trim()
    || t('breakoutGroupN', { n: breakout.group_number || 1 });
  // The reader's id rides on the payload (`me`), because neither home publishes it; the prop is
  // the override for a caller that does know.
  const mine = String(me || breakout.me || '').toLowerCase();
  const others = (breakout.members || []).filter((p) => p.id !== mine && p.name);
  // The moment on the run sheet this belongs to, when it belongs to one. An unattached breakout
  // says nothing rather than inventing a time.
  const when = [breakout.planning_title, (breakout.planning_start || '').slice(11, 16)]
    .filter(Boolean).join(' · ');

  return (
    <div className="mybo mt-3">
      <p className="bravos-cal__label mb-1">
        <Icon name="users" className="me-2" />
        {breakout.breakout_name || t('yourBreakout')}
      </p>
      <p className="mybo__group mb-1">{t('youAreInGroup', { group: label })}</p>
      {breakout.location && <p className="mybo__where mb-1">{breakout.location}</p>}
      {when && <p className="mybo__where mb-1">{when}</p>}
      {others.length > 0 && (
        <p className="mybo__with mb-0">
          {t('breakoutWith', { names: others.map((p) => p.name).join(', ') })}
        </p>
      )}
    </div>
  );
};

export default MyBreakout;
